import React from 'react';

const StatusGrid = ({ children }) => {
    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1.5rem',
        }}>
            {children}
        </div>
    );
};

export default StatusGrid;
